var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48 31V6H49C49.55 6 50 5.55 50 5V1C50 0.45 49.55 0 49 0H9C8.45 0 8 0.45 8 1V5C8 5.55 8.45 6 9 6H10V14.09C7.17 14.57 5 17.03 5 20C5 21.95 5.93 23.67 7.37 24.77C4.21 26.17 2 29.33 2 33V40C2 40.55 2.45 41 3 41H6V48H1C0.45 48 0 48.45 0 49C0 49.55 0.45 50 1 50H49C49.55 50 50 49.55 50 49C50 48.45 49.55 48 49 48H16V41H19C19.55 41 20 40.55 20 40V33C20 32.66 19.98 32.33 19.94 32H34.76L42.55 35.89C43.25 36.29 44.1 35.62 43.99 34.86L43.58 32H47C47.55 32 48 31.55 48 31ZM10 2H48V4H10V2ZM7 20C7 17.79 8.79 16 11 16C13.21 16 15 17.79 15 20C15 22.21 13.21 24 11 24C8.79 24 7 22.21 7 20ZM18 39H16V36C16 35.45 15.55 35 15 35C14.45 35 14 35.45 14 36V48H12V42C12 41.45 11.55 41 11 41C10.45 41 10 41.45 10 42V48H8V36C8 35.45 7.55 35 7 35C6.45 35 6 35.45 6 36V39H4V33C4 29.14 7.14 26 11 26C14.86 26 18 29.14 18 33V39ZM46 30H42.43C41.84 30 41.36 30.53 41.44 31.14L41.74 33.25L35.45 30.11C35.31 30.04 35.16 30 35 30H19.47C18.64 27.66 16.88 25.77 14.63 24.77C16.07 23.67 17 21.95 17 20C17 17.03 14.83 14.57 12 14.09V6H46V30Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43 26V22C43 21.45 42.55 21 42 21H38C37.45 21 37 21.45 37 22V26H35V20C35 19.45 34.55 19 34 19H30C29.45 19 29 19.45 29 20V26H27V17C27 16.45 26.55 16 26 16H22C21.45 16 21 16.45 21 17V26C20.45 26 20 26.45 20 27C20 27.55 20.45 28 21 28H43C43.55 28 44 27.55 44 27C44 26.45 43.55 26 43 26ZM25 26H23V18H25V26ZM33 26H31V21H33V26ZM41 26H39V23H41V26Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38 18C40.76 18 43 15.76 43 13C43 10.24 40.76 8 38 8C35.24 8 33 10.24 33 13C33 15.76 35.24 18 38 18ZM41 13C41 13.46 40.89 13.89 40.7 14.29L39 12.59V10.19C40.16 10.6 41 11.7 41 13.01V13ZM37 10.18V13C37 13.27 37.11 13.52 37.29 13.71L39.28 15.7C38.89 15.89 38.46 16 37.99 16C36.34 16 34.99 14.65 34.99 13C34.99 11.7 35.83 10.6 36.99 10.18H37Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 10H29C29.55 10 30 9.55 30 9C30 8.45 29.55 8 29 8H19C18.45 8 18 8.45 18 9C18 9.55 18.45 10 19 10Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19 14H24C24.55 14 25 13.55 25 13C25 12.45 24.55 12 24 12H19C18.45 12 18 12.45 18 13C18 13.55 18.45 14 19 14Z",
    fill: "#0A71FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI10);
export default __webpack_public_path__ + "static/media/i10.921bc7db686f8ad0ae27b04cc2c6e208.svg";
export { ForwardRef as ReactComponent };